import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * ClassColorLegend
 * Reusable legend for displaying class color mappings.
 * Props:
 *  - classes: array of class objects ({name}) or plain strings
 *  - colorMap: { [className]: color }
 *  - title: custom title text (default: 'Şube Renkleri')
 *  - showDivider: boolean to render a top divider
 *  - sx: additional Box styles applied to root container
 */
export default function ClassColorLegend({ classes = [], colorMap = {}, title = 'Şube Renkleri', showDivider = false, sx = {} }) {
  const names = (classes || [])
    .map(c => (typeof c === 'string' ? c : c?.name))
    .filter(Boolean)
    .sort((a,b)=>String(a).localeCompare(String(b),'tr-TR'));
  if (!names.length) return null;
  return (
    <Box sx={{ mt: 2, ...sx }}>
      {showDivider && <Box sx={{ mb: 1, borderTop: '1px solid', borderColor: 'divider' }} />}
      <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, mr: 0.5 }}>{title}:</Typography>
        {names.map(name => (
          <Box
            key={name}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              px: 1,
              py: 0.5,
              borderRadius: 1,
              fontSize: 12,
              fontWeight: 600,
              bgcolor: colorMap?.[name] || 'grey.500',
              color: '#fff',
              boxShadow: '0 0 0 1px rgba(0,0,0,0.08)',
              letterSpacing: 0.25
            }}
          >
            {name}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
